import React from 'react';
import _ContentDispatch from 'app-ui-componentlibrary/dist/framework/components/contentDispatch';
import contentMap from 'componentLibrary';

export const ContentDispatch = (props) => (
  <_ContentDispatch {...props} {...{contentMap}} />
);
